module.exports = __webpack_public_path__ + "static-portal/img/custom-bg.e9ba77a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-bg.jpg
// module id = 5SJP
// module chunks = 4